<template>
  <div class="shop_warp">
    <van-sticky>
      <van-cell title="品牌选择" is-link @click="showBrand" v-if="beeType==2">
        <template #default>
          <div class="default_item">
            <van-image :src="brandImg"  width="20" height="20" v-show="brandImg"></van-image>
            <span class="van-ellipsis" style="width:200px">{{brandName}}</span>
          </div>
        </template>
      </van-cell>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-card
          :price="item.price"
          :desc="item.branchName"
          :title="item.itemName"
          :thumb="item.indexImage && item.indexImage.imageUrl+'?x-oss-process=style/style_myfav_goods_img'"
          :origin-price="item.markingPrice"
          v-for="(item,index) in dataList"
          :key="index"
        >
          <!-- <div slot="tags">
            <van-tag plain type="danger">标签</van-tag>
            <van-tag plain type="danger">标签</van-tag>
          </div>-->
          <div slot="footer" v-if="beeType==1">
            <van-button size="mini" @click="lowerShelf(item)">{{item.upShelf==='y'?'下架':'已下架'}}</van-button>
            <van-button size="mini" @click="editmange(item)">修改库存</van-button>
          </div>
        </van-card>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="show" :style="{ height: '80%' }" round position="bottom" closeable>
      <div class="warp">
        <div class="title_warp">品牌选择</div>
        <div class="search_warp">
          <van-search
            v-model="value"
            placeholder="请输入想要选择的店铺"
            shape="round"
            @search="onSearch"
            show-action
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </div>
        <div class="content-warp">
          <ul>
            <li class="content-warp-title content-warp-item">
              <div class="witdh45">LOGO</div>
              <div class="widtd80">店铺名称</div>
              <div class="widtd60">所属品牌</div>
            </li>
          </ul>
          <ul class="sroll_warp_item">
            <li
              class="content-warp-item content-warp-info van-hairline--bottom"
              v-for="(item,index) in onSearch"
              :key="index"
              @click="setBrand(item)"
            >
              <div class="witdh45"><van-image :src="item && item.shopLogoUrl+'?x-oss-process=style/style_myfav_goods_img'" width="45" height="45"></van-image></div>
              <div style="color:#666;" class="van-ellipsis widtd80">{{item.shopName}}</div>
              <div style="color:#ccc;" class="van-ellipsis widtd60">{{item.brandName}}</div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import http from "@/utils/axios";
export default {
  data() {
    return {
      value: "",
      pageIndex: 0,
      refreshing: false,
      loading: false,
      finished: false,
      brandName: "",
      brandImg:'',
      beeType: 1,
      branchNo: "",
      show: false,
      brandList: [],
      dataList: []
    };
  },
  methods: {
    onLoad() {
      this.pageIndex++;
      this.getPageShop();
      console.log(1);
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.brandName='',
      this.branchNo='',
      this.brandImg='',
      this.dataList= [];
      this.onLoad();
    },
    lowerShelf(item) {
      let parmes = {
        id: item.id,
        upShelf: "n"
      };
      if (item.upShelf === "y") {
        parmes.upShelf = "n";
      } else {
        return;
      }
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认下架吗?"
        })
        .then(() => {
          http({
            url: "item/item/quick/bees/upShelf",
            method: "put",
            parmes: parmes
          }).then(rps => {
            if (rps.code === 200) {
              this.$notify({ type: "success", message: "操作成功！" });
              this.getPageShop();
            } else {
              // this.$notify({type:"wang",message:rps.message})
            }
          });
        });
    },
    getPageShop() {
      http({
        url: "item/item/quick/bees/page",
        method: "post",
        parmes: {
          pageIndex: this.pageIndex,
          pageSize: 10,
          branchNo: this.branchNo
        }
      }).then(rps => {
        if (rps.code === 200) {
          this.refreshing = false;
          if (rps.data.length > 0) {
            rps.data.forEach(item => {
              this.dataList.push(item);
            });
            this.loading = false;
          } else {
            this.finished = true;
          }
        }
      });
    },
    editmange(item) {
      this.$router.push({ path: `/editshop/${item.id}/${item.itemName}` });
    },
    getBeetype() {
      http({
        url: "shop/bees/bees/"
      }).then(rps => {
        if (rps.code == 200) {
          this.beeType = rps.data.beeType;
        }
      });
    },
    showBrand() {
      this.show = !this.show;
    },
    // 选择某个品牌
    setBrand(item) {
      this.branchNo = item.shopId;
      this.brandName = item.shopName;
      this.brandImg = item.shopLogoUrl;
      this.dataList = [];
      this.pageIndex=1;
      this.showBrand();
      this.getPageShop();
    },
    //品牌列表
    getBrand() {
      http({
        url: "base/branch/branch/getBeeBranch",
        method: "get"
      }).then(rps => {
        if (rps.code == 200) {
          this.brandList = rps.data;
        }
      });
    }
  },
  created() {
    this.getBeetype();
    this.getBrand();
    this.$loading.hide();
  },
  computed: {
    onSearch() {
      return this.brandList.filter(item => {
        return item.brandName.indexOf(this.value) > -1;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.shop_warp {
  width: 100%;
  .van-card {
    &:first-child {
      margin-top: 20px;
    }
  }
  .van-card__price {
    color: red;
  }
  .default_item{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.warp {
  .title_warp {
    font-size: 32px;
    color: #000;
    padding: 35px 30px;
  }
  .content-warp {
    padding: 10px 30px;
    .sroll_warp_item {
      height: 600px;
      overflow-y: scroll;
    }
    .content-warp-title {
      background: #f2f2f2;
      font-size: 24px;
      padding: 30px 0;
    }
    .content-warp-item {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .content-warp-info {
      padding: 10px 0;
      font-size: 24px;
    }
    .widtd80{
      width: 230px;
    }
    .witdh45{
      width: 90px;
    }
    .widtd60{
      width: 120px;
    }
  }
}
</style>